<template>
  <v-container fluid>
      <v-row no-gutters>
          <v-col cols="12" lg="6" sm="12">
              <v-card>
                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="headline">ユーザー情報登録</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-card-text>
                    <v-form ref="user_master_form" v-model="valid" @submit.prevent>
                        <v-text-field label="名前" v-model="name" :counter="10" :rules="nameRules" dense outlined>
                            <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                            </template>
                        </v-text-field>
                        <v-text-field ref="user_email" label="メールアドレス" v-model="email" :rules="emailRules" dense outlined>
                            <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                            </template>
                        </v-text-field>
                        <v-select label="部署" :items="departmentItems" item-text="name" item-value="value" v-model="department" :rules="departmentRules" no-data-text="データがありません" dense outlined return-object>
                            <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                            </template>
                        </v-select>
                        <v-select label="等級" :items="rankItems" item-text="name" item-value="value" v-model="rank" :rules="rankRules" no-data-text="データがありません" dense outlined return-object>
                            <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                            </template>
                        </v-select>
                        <v-select label="権限" :items="authorityItems" item-text="name" item-value="value" v-model="authority" :rules="permissionRules" no-data-text="データがありません" dense outlined return-object>
                            <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                            </template>
                        </v-select>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field label="休憩(時間)" suffix="時間" v-model="workerBreakHourTime" :rules="workerBreakHourTimeRules" dense outlined>
                              <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field label="休憩(分)" suffix="分" v-model="workerBreakMinuteTime" :rules="workerBreakMinuteTimeRules" dense outlined>
                              <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-text-field type="password" label="パスワード" v-model="password" :counter="16" :rules="passwordRules" dense outlined>
                            <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                            </template>
                        </v-text-field>
                        <password v-model="password" :strength-meter-only="true" @score="showScore"/>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'UserMaster' }" depressed>キャンセル</v-btn>
                    <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
                </v-card-actions>
              </v-card>
          </v-col>
      </v-row>
      <v-row justify="center">
        <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleStore
            @stored="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
    import { useAppInsights } from '@/plugins/application-insights';
    import Password from "vue-password-strength-meter";
    import Rule from "@/validation/rules";
    import CustomDialog from "@/components/custom_ui/CustomDialog";
    import UserMasterApi from "@/api/user-master-api";
    import statusList from "@/helpers/const";

    export default {
        name: "UserMasterEntry",
        components: {
            Password,
            CustomDialog
        },
        data: () => ({
            loading: false,
            name: "",
            email: "",
            department: null,
            departmentItems: [],
            rank: null,
            rankItems: [],
            authority: null,
            authorityItems: [],
            password: "",
            passwordRuleslength: 0,
            passwordScore: 0,
            scoreApproveLevel: 3,
            workerBreakHourTime: 0,
            workerBreakMinuteTime: 0,

            // 登録ダイアログ
            dialogMaxWith: 500,
            dialogTitle: "",
            dialogItems: [],
            dialogDrawer: false,
            editId: null,

            // バリデーション
            valid: true,
            nameRules: Rule.nameRules,
            emailRules: Rule.emailRules,
            passwordRules: Rule.passwordRules,
            rankRules: Rule.rankRules,
            departmentRules: Rule.departmentRules,
            passwordValid: true,
            permissionRules: Rule.permissionRules,
            workerBreakHourTimeRules: Rule.defaultBreakHourTimeRules,
            workerBreakMinuteTimeRules: Rule.defaultBreakMinuteTimeRules
        }),
        created() {
            this.initialize();
        },
        watch: {
            email (value) {
                this.email = this.stringFormat(value);
                this.$refs.user_email.internalValue = this.email;
            },
        },
        methods: {
            isLoading() {
                this.loading = !this.loading;
                this.$emit("loading", this.loading);
            },
            initialize () {
                this.isLoading();
                this.userMasterApi = new UserMasterApi();
                this.passwordRuleslength = this.passwordRules.length;
                this.editId = "0";
                const promise = this.userMasterApi.info(this.editId);
                promise.then((response) => {
                    for (var department of response.data.body.department_info) {
                        var department_name = department.name;
                        if (department.section) {
                            department_name = department.name + " - " + department.section;
                        }
                        this.departmentItems.push({
                            name: department_name,
                            value: department.id
                        });
                    }
                    for (var rank of response.data.body.rank_info) {
                        this.rankItems.push({
                            name: rank.name,
                            value: rank.id
                        });
                    }
                    for (var permission of response.data.body.permission_info) {
                        this.authorityItems.push({
                            name: permission.permission_name,
                            value: permission.id
                        });
                    }
                }).catch(error => {
                    useAppInsights().trackException({exception: error});
                    if (error.response) {
                        if (error.response.data.status == statusList.status.authError) {
                            this.$emit('logoutConform');
                        } else {
                            this.$emit("error",error.response.data.message);
                        }
                    } else {
                        this.$emit("error","サーバーエラーが発生しました。");
                    }
                }).finally(() => {
                    this.isLoading();
                });
            },
            stringFormat(value) {
                var result = value.toString()
                while (result.match(/[ぁ-んァ-ヶ亜-熙]+/g)) {
                  result = result.replace(/[ぁ-んァ-ヶ亜-熙]+/g, "");
                }
                while (result.match(/[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g)) {
                    result = result.replace(/[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g, function(s) {
                    return String.fromCharCode(s.charCodeAt(0) - 65248);
                    });
                }
                return result;
            },
            showScore (score) {
                this.passwordScore = score;
                if (this.passwordRules.length > this.passwordRuleslength) {
                    this.passwordRules.pop()
                }
                if (this.passwordScore < this.scoreApproveLevel) {
                    this.passwordRules.push("パスワードの強度がたりません")
                }
            },
            checkDialog() {
                this.dialogTitle = "登録しますか？";
                this.dialogItems = [
                    { name: "名前", value: this.name },
                    { name: "メールアドレス", value: this.email },
                    { name: "部署", value: this.department.name },
                    { name: "等級", value: this.rank.name },
                    { name: "権限", value: this.authority.name },
                    { name: "休憩(時間)", value: this.workerBreakHourTime },
                    { name: "休憩(分)", value: this.workerBreakMinuteTime },
                ];
                this.dialogDrawer = true;
            },
            dialogCancel() {
                this.dialogDrawer = false;
            },
            submit() {
                if (this.$refs.user_master_form.validate()) {
                    this.isLoading();
                    const promise = this.userMasterApi.store({
                        name: this.name,
                        email: this.email,
                        password: this.password,
                        permission_id: String(this.authority.value),
                        rank_id: String(this.rank.value),
                        department_id: String(this.department.value),
                        profile_icon_name: this.name.slice(0,1),
                        worker_break_hour_time: this.workerBreakHourTime,
                        worker_break_minute_time: this.workerBreakMinuteTime
                    });
                    promise.then((response) => {
                        this.$emit('success', response.data.message);
                        this.$router.push({ name: 'UserMaster' });
                    }).catch(error => {
                        useAppInsights().trackException({exception: error});
                        if (error.response) {
                            if (error.response.data.status == statusList.status.authError) {
                                this.dialogDrawer = false;
                                this.$emit('logoutConform');
                            } else {
                                this.$emit("error",error.response.data.message);
                            }
                        } else {
                            this.$emit("error","サーバーエラーが発生しました。");
                        }
                    }).finally(() => {
                        this.isLoading();
                    });
                }
            }
        }
    };
</script>
